import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import DropFile from '@/components/base/DropFile.vue';

type Props = {
  url?: string | undefined | null;
  articleId?: string | undefined;
  type: 'Cover' | 'Poster';
  imgSize: number[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleCoverUploader',
  props: {
    url: null,
    articleId: null,
    type: null,
    imgSize: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', f: File): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  url?: string | undefined | null;
  articleId?: string | undefined;
  type: 'Cover' | 'Poster';
  imgSize: number[];
}





const file = ref<File | null>(null);
const isChanged = ref(false);

const previewUrl = ref(props.url);
const imageExists = ref(!!previewUrl.value);

watch(imageExists, (newVal) => {
  if (!newVal) {
    // Image not processed, will attempt to reload after delay.
    setTimeout(() => {
      imageExists.value = true;
      previewUrl.value = `${props.url}?t=${new Date().getTime()}`; // Force reload by appending timestamp
    }, 5000);
  }
});

/* A cover only gets a url once the image has been created and the article patched, which
   happens after this component is already mounted. Adopt the url when it arrives, otherwise
   the preview keeps showing the previous cover - or the file we just cropped locally - and
   there is no way to tell from the form whether the save actually worked. */
watch(
  () => props.url,
  (url) => {
    if (!url) return;
    previewUrl.value = url;
    imageExists.value = true;
  },
);

const changeHandler = (inputFiles: File[]) => {
  if (!inputFiles || !inputFiles.length) {
    isChanged.value = false;
    return;
  }

  isChanged.value = true;
  const imageFile = inputFiles[0];
  const image = new Image();
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const desiredWidth = props.imgSize[0]; // desired width
  const desiredHeight = props.imgSize[1]; // desired height

  image.onload = () => {
    canvas.width = desiredWidth;
    canvas.height = desiredHeight;

    const offsetX = (image.width - desiredWidth) / 2;
    const offsetY = (image.height - desiredHeight) / 2;

    ctx?.drawImage(image, offsetX, offsetY, desiredWidth, desiredHeight, 0, 0, desiredWidth, desiredHeight);

    canvas.toBlob((blob) => {
      if (blob) {
        const croppedFile = new File([blob], imageFile.name, { type: imageFile.type });
        file.value = croppedFile;
        previewUrl.value = URL.createObjectURL(croppedFile);
        emits('input', croppedFile);
      }
    }, imageFile.type);
  };

  image.src = URL.createObjectURL(imageFile);
};

return { __sfc: true,props, emits, file, isChanged, previewUrl, imageExists, changeHandler, DropFile }
}

})